export enum FilterOrderTypes {
  TP,
  SL_ATRATE,
  TSL,
  CALL,
  ALGO,
  BMARK,
  // BMRT,
  BMHO,
  MARKET,
  BMALGO,
}
export enum OrderBlotterFilterOrderStates {
  ACTIVE,
  TRIGGERED,
  PENDING,
  SUSPENDED,
  IN_MODIFICATION,
  ACCEPTANCE_NEEDED,
  CANCEL_ACCEPTANCE_NEEDED,
  MODIFY_ACCEPTANCE_NEEDED,
  PENDING_CANCELLATION,
  MIGRATION_ACCEPTANCE_NEEDED,
  FILLING,
}

export enum BenchmarkBlotterFilterOrderStates {
  ACTIVE,
  PENDING,
  IN_MODIFICATION,
  FILL_ERROR,
  FILLED,
  REJECTED,
  CANCELLED,
  PAUSED,
  FILL_EXPIRED,
  ACCEPTANCE_NEEDED,
  ACCEPTANCE_NEEDED_MODIFY_LOCK, // Modify in pending
  CANCEL_ACCEPTANCE_NEEDED,
  EXT_ACCEPTANCE_NEEDED,
  EXT_CANCEL_ACCEPTANCE_NEEDED,
}

export enum TraderBlotterFilterDealStates {
  STP_PENDING,
  STP_TIMEOUT,
  STP_FAILED,
  STP_COMPLETE,
  STP_DISABLED,
}

export enum OrderBlotterFilterAutoEligible {
  Yes,
  No,
}

export enum ForwardRollEnum {
  NONE,
  MANUAL,
  AUTO,
}
